import clsx from 'clsx';
import React from 'react';
export const RouteLoader = (props) => {
    const { inline } = props;
    return (React.createElement("div", { className: clsx('flex justify-center items-center pointer-events-none', {
            'w-full py-6': inline,
            'fixed inset-0': !inline,
        }) },
        React.createElement("div", { className: "w-full h-64 flex justify-center items-center flex-col" },
            React.createElement("div", { className: "spinner w-16 h-12 text-gray-400" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null))),
        React.createElement("p", { className: "sr-only" }, "Loading...")));
};
